import { removeItem, setItem } from './local-storage';

export function broadcastMessageToTabs(key, value) {
  setItem(key, value);
  removeItem(key);
}
